import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../context/Context";

const ProtectedRoute = ({ children }) => {
  const [userData] = useContext(UserContext);
  const token = localStorage.getItem("auth-token");

  if (userData?.user || token) {
    return children;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
